/* Movasana — Kaufzeile im PiFi-Aufbau.
   Schiebt die Anzahl (.product-form__quantity) in die Button-Gruppe
   (.product-form__buttons), direkt vor "In den Warenkorb". Dadurch liegen
   Anzahl und Warenkorb in einer Reihe; "Buy with shop" bricht darunter voll
   breit um (per CSS auf .mv-buyrow).

   Warum JS statt Markup: bei zwei Produkten (Rueckenstrecker, Reformer-Board)
   stehen custom_liquid/text-Bloecke ZWISCHEN Anzahl und buy_buttons — die beiden
   sind also nicht immer DOM-benachbart. Das Verschieben ist unabhaengig von der
   Blockreihenfolge.

   Warum das Dawns Varianten-Wechsel ueberlebt: product-info.js haelt die Anzahl
   ueber eine gecachte Referenz (this.quantityForm) und aktualisiert nur deren
   Sub-Elemente in-place; der Knoten selbst wird nie ersetzt oder umgehaengt. */
(function () {
  function moveQuantityIntoButtons(scope) {
    var groups = (scope || document).querySelectorAll('.product-form__buttons');
    for (var i = 0; i < groups.length; i++) {
      var buttons = groups[i];
      if (buttons.classList.contains('mv-buyrow')) continue;

      // Die Anzahl gehoert zum selben Produkt-Container wie die Buttons.
      var container =
        buttons.closest('product-info') ||
        buttons.closest('.product__info-container') ||
        buttons.closest('.shopify-section');
      if (!container) continue;

      var qty = container.querySelector('.product-form__quantity');
      if (!qty || buttons.contains(qty)) continue;

      buttons.insertBefore(qty, buttons.firstElementChild);
      buttons.classList.add('mv-buyrow');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      moveQuantityIntoButtons();
    });
  } else {
    moveQuantityIntoButtons();
  }
})();
